import * as React from "react";
import {ListGroup} from "react-bootstrap";
import {GuidelineModel} from "../../../../../models/domain/guidelineModel";
import {FaPlusCircle} from "react-icons/fa";

export const ProductInfoAndInstallation = ({
                                               model: {
                                                   title,
                                                   resourceCount,
                                                   hasResources,
                                                   resources,
                                                   moreToShow,
                                                   showAll
                                               }
                                           }: {
    model: {
        title: string;
        resourceCount: number;
        hasResources: boolean;
        resources: GuidelineModel[];
        moreToShow: boolean;
        showAll: () => void;
    };
}) => {
    // If there are no instructions or warranty guidelines, return an empty fragment
    if (!hasResources) return <></>;

    return (
        <>
            <ListGroup variant="flush" className="mt-0">
                <ListGroup.Item className="bg-light border-top">
                    <strong>
                        {title}
                    </strong>
                </ListGroup.Item>
                {resources.map(({filename, url}, index) => (
                    <ListGroup.Item action href={url} target="_blank" className="text-info dont-break-out" key={index}>
                        {filename}
                    </ListGroup.Item>
                ))}
                {moreToShow && (
                    <ListGroup.Item onClick={showAll} action className="text-info d-flex align-items-center">
                        <FaPlusCircle className="me-1" aria-hidden/>Show all {resourceCount} documents
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    );
};